import { Component, OnDestroy } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { trackByRef } from 'src/app/lego-utils';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Subscription } from 'rxjs';
import { QuickUrlFormGroup } from 'src/app/components/main-content/admin/manage-quick-urls/create-quick-url-drawer/quick-url-form-group';
import { Roles } from 'src/app/models/domain';
import { IQuickUrl, QuickUrlService } from 'src/app/state';

@Component({
  selector: 'em-create-quick-url-drawer',
  templateUrl: './create-quick-url-drawer.component.html',
  standalone: false,
})
export class CreateQuickUrlDrawerComponent implements OnDestroy {
  public formGroup: QuickUrlFormGroup;
  public isSaving = false;
  public listOfOptions = Object.values(Roles);
  public readonly trackByRef = trackByRef.bind(undefined);
  private readonly subscriptions = new Subscription();

  public constructor(
    private readonly formBuilder: FormBuilder,
    private readonly quickUrlService: QuickUrlService,
    private readonly drawerRef: NzDrawerRef,
    private readonly messageService: NzMessageService
  ) {
    const control = <T>(value: T, opts?: Parameters<FormBuilder['control']>[1]) =>
      this.formBuilder.control(value, opts);

    const requiredValidator = Validators.required.bind(Validators);

    this.formGroup = this.formBuilder.group({
      accessedBy: control<string[]>([], {
        nonNullable: true,
        validators: [requiredValidator],
      }),
      label: control<string>('', {
        nonNullable: true,
        validators: [requiredValidator],
      }),
      url: control<string>('', {
        nonNullable: true,
        validators: [requiredValidator],
      }),
    }) as QuickUrlFormGroup;
  }

  public submitForm() {
    this.isSaving = true;

    const { accessedBy, label, url } = this.formGroup.getRawValue();

    const data: IQuickUrl = {
      accessedBy,
      label,
      shortname: this.quickUrlService.generateShortname(label),
      url,
    };

    this.subscriptions.add(
      this.quickUrlService.create(data).subscribe({
        next: () => {
          this.messageService.create('success', 'Successfully added URL');
          this.drawerRef.close();
        },
        error: (error: unknown) => {
          const errorMessage = error instanceof Error ? error.message : 'An unknown error occurred';
          this.messageService.create('error', errorMessage);
          this.isSaving = false;
        },
      })
    );
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
